import type { SchemaField, SlotAreaFields } from '@cli-types/core-engine/schema.js'
import { isRecord } from '@cli-utils/shared.js'

export function slotAreaFields(slot: unknown): SlotAreaFields {
  const readArea = (area: unknown): SchemaField[] =>
    isRecord(area) && Array.isArray(area.fields) ? (area.fields as SchemaField[]) : []

  if (!isRecord(slot)) {
    return { main: [], sidebar: [] }
  }

  return { main: readArea(slot.main), sidebar: readArea(slot.sidebar) }
}
